"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'placeholder', 'readonly'],
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            internalReadonly: model.readOnly || this.readonly
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/TextMultiline.vue
// module id = 181
// module chunks = 0